import FontLoader from '@/components/global/FontLoader';

const FontLoaderWrapper = ({ blok: { fontName, s3Path } }) => {
  return <FontLoader fontName={fontName} s3Path={s3Path} fullPath />;
};

export default FontLoaderWrapper;
